import React from "react";
import { BsFillCheckCircleFill } from "react-icons/bs";
import Calculator from "./Calculator";
import Navbar from "./Navbar";
import { Swiper, SwiperSlide } from "swiper/react";
import play from "../assets/play.png";
import apple from "../assets/app.png";
import cios from "../assets/cios.png";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Autoplay, Pagination, Navigation } from "swiper";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../Contexts/AuthContext";

const Hero = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  return (
    <div className="Hero_section mt-10 px-md-3 py-md-2">
      <style>{`
        /* --- Walletven-style hero buttons (accent is the brand red) --- */

        @media (max-width: 500px){
        .wv-hero-btn{
        padding-left: 15px !important;
        padding-right: 15px !important;
        }}
        .wv-hero-btn {
          --accent: #F6394F;
          --accent-strong: #e22440;
          --ink: #101828;

          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 1rem;
          padding: 14px 30px;
          border-radius: 12px;
          cursor: pointer;
          transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, transform 0.05s ease;
        }
        .wv-hero-btn:active { transform: translateY(1px); }

        /* primary = solid red */
        .wv-hero-btn.primary {
          background: var(--accent);
          color: #ffffff;
          border: 1.5px solid var(--accent);
        }
        .wv-hero-btn.primary:hover {
          background: var(--accent-strong);
          border-color: var(--accent-strong);
        }

        /* secondary = outlined (use this class if you add a second button) */
        .wv-hero-btn.outline {
          background: #ffffff;
          color: var(--ink);
          border: 1.5px solid var(--ink);
        }
        .wv-hero-btn.outline:hover {
          background: var(--ink);
          color: #ffffff;
        }
      `}</style>

      <Navbar />
      <div
        className="d-flex justify-content-between align-items-center 
      hero_main canvas"
      >
        <div className="w-50">
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: false,
            }}
            navigation={false}
            modules={[Autoplay]}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="pb-2">
                <h1 className="hero_h mt-md-0 mt-4">
                 Tus envíos a Venezuela.
Simple y Seguro.
                </h1>
                <div className="mt-md-3 mt-2">
                  <p>
                    {/* Tú decides cómo recibir tu dinero, en Criptomonedas o Bolívares en Cuentas Bancarias de cualquier Banco de Venezuela. */}
                    Envía dinero a tus familiares y amigos de manera rápida y garantizada, a través de Cuentas Bancarias y Pago Móvil.
                  </p>

                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className="pb-2">
                <h1 className="hero_h">
                  Envía a Venezuela en Bolívares o a wallets USDT.
                </h1>
                <div className="mt-md-3 mt-2">
                  <p>
                    Servicio disponible para toda la Unión Europea. Más de 9 años brindando soluciones a nuestros clientes.
                  </p>
                </div>
              </div>
            </SwiperSlide> */}
          </Swiper>
          <div className="d-flex gap-3 mt-md-3 mt-2 align-items-stretch">
            <button
              className="wv-hero-btn primary"
              onClick={() => navigate("/registro")}
            >
              Abrir Cuenta
            </button>
            <div className="d-flex align-items-end">
              <Link to={"https://play.google.com/store/apps/details?id=com.transferven.app"} target="_blank">
                <img src={play} width={175} />
              </Link>
            </div>
          </div>
        </div>
        <Calculator btn={true} />
      </div>
    </div>
  );
};

export default Hero;